export const deleteSvg = 'data:image/svg+xml,%3Csvg width=\'61\' height=\'61\' viewBox=\'0 0 61 61\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'30.5\' cy=\'30.5\' r=\'30.5\' fill=\'%23fff\'/%3E%3Cpath d=\'M21 21l19 19m0-19L21 40\' stroke=\'%23000\' stroke-width=\'3\' strokeLinecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E'
export const scaleSvg = 'data:image/svg+xml,%3Csvg width=\'61\' height=\'61\' viewBox=\'0 0 61 61\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'30.5\' cy=\'30.5\' r=\'30.5\' fill=\'%23fff\'/%3E%3Cpath d=\'M18.52 19.744a1 1 0 0 1 1.224-1.225l13.384 3.587a1 1 0 0 1 .449 1.673l-9.798 9.798a1 1 0 0 1-1.673-.449l-3.587-13.384zM39.94 41.319a1 1 0 0 0 1.224-1.225L37.578 26.71a1 1 0 0 0-1.673-.448l-9.798 9.798a1 1 0 0 0 .448 1.673l13.385 3.586z\' fill=\'%23000\'/%3E%3C/svg%3E';
export const rotateSvg = 'data:image/svg+xml,%3Csvg width=\'61\' height=\'61\' viewBox=\'0 0 61 61\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle r=\'30.5\' transform=\'matrix(1 0 0 -1 30.5 30.5)\' fill=\'%23fff\'/%3E%3Cpath d=\'M18.223 30.696L12.199 32c-.131-.85-.199-1.722-.199-2.609C12 19.786 19.96 12 29.78 12c8.285 0 15.246 5.543 17.22 13.044M41.777 30.304L47.801 29c.131.85.199 1.722.199 2.609C48 41.214 40.04 49 30.22 49 21.935 49 14.974 43.458 13 35.956\' stroke=\'%23000\' stroke-width=\'3\' strokeLinecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E';
export const fontTabs = [
  {
    title: "Font Family",
    key: 0,
  },
  {
    title: "Font Color",
    key: 1,
  },
  {
    title: "Font Style",
    key: 2,
  },
  {
    title: "　　　　　　　",
    key: 3,
  },
];